import css from 'styled-jsx/css'
import { measurements, colors, fontSizes } from 'theme'
import { iadProvitionalColors } from 'theme/colors'

export default css`
  .simple-label-as-disabled-input {
    width: 100%;
    min-height: 2rem;
    margin-bottom: 1rem;
    color: ${iadProvitionalColors.black};
    border-radius: ${measurements.borderRadius};
    background-color: ${colors.alpha(colors.gray, 0.6)};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: ${fontSizes.p};
    font-weight: bold;
    word-break: break-word;
    line-height: 1.5rem;
    padding: 0.5rem 0;
  }
`
